<template>
  <div class="page-block">
    <div
      class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        サブミット設定
      </h3>
      <release-type-label :type="type" />
    </div>
    <div
      v-if="!isSubmitConfirmed"
      class="page-block__inner">
      <div
        v-if="Object.keys(confirmProductErrors).length">
        <alert-view
          :errors="confirmProductErrors" />
      </div>
      <form class="form--error">
        <div class="form-wrap">
          <div class="form-group">
            <div class="form-label">
              <span class="control-label control-required">*</span>
              <label
                class="control-label">アーティスト活動歴 :</label>
            </div>
            <div class="form-item-inline">
              <span class="radio">
                <label for="within2years">
                  <input
                    id="within2years"
                    v-model="submitData.artistActivityHistory"
                    name="artistActivityHistory"
                    type="radio"
                    value="2年以内"
                    checked
                    @change="handleValidation">
                  <div class="option-input"></div> 2年以内
                </label>
              </span>
              <span class="radio">
                <label for="moreThan2years">
                  <input
                    id="moreThan2years"
                    v-model="submitData.artistActivityHistory"
                    name="artistActivityHistory"
                    type="radio"
                    value="2年以上"
                    @change="handleValidation">
                  <div class="option-input"></div> 2年以上
                </label>
              </span>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-group">
            <div class="form-label">
              <span class="control-label control-required">*</span>
              <label
                class="control-label">デビュー作ですか？ :</label>
            </div>
            <div class="form-item-inline">
              <span class="radio">
                <label for="true">
                  <input
                    id="true"
                    v-model="submitData.isDebut"
                    name="isDebut"
                    type="radio"
                    value="はい"
                    checked
                    :disabled="isDisabled">
                  <div class="option-input"></div> はい
                </label>
              </span>
              <span class="radio">
                <label for="false">
                  <input
                    id="false"
                    v-model="submitData.isDebut"
                    name="isDebut"
                    type="radio"
                    value="いいえ">
                  <div class="option-input"></div> いいえ
                </label>
              </span>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-group">
            <div class="form-label">
              <span class="control-label control-required">*</span>
              <label
                class="control-label">CDリリース予定 :</label>
            </div>
            <div class="form-item-inline">
              <span class="radio">
                <label for="canBe">
                  <input
                    id="canBe"
                    v-model="submitData.cdReleaseSchedule"
                    name="cdReleaseSchedule"
                    type="radio"
                    value="あり"
                    checked>
                  <div class="option-input"></div> あり
                </label>
              </span>
              <span class="radio">
                <label for="none">
                  <input
                    id="none"
                    v-model="submitData.cdReleaseSchedule"
                    name="cdReleaseSchedule"
                    type="radio"
                    value="なし">
                  <div class="option-input"></div> なし
                </label>
              </span>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-group">
            <div class="form-label">
              <span class="control-label control-required">*</span>
              <label
                class="control-label">キャッチコピー :</label>
            </div>
            <div class="form-item">
              <div class="form-label">
                <label
                  class="control-label">日本語 :</label>
              </div>
              <textarea
                id="catchCopyJapanese"
                v-model="submitData.catchCopyJapanese"
                maxlength="35"
                class="form-control"
                type="text"
                placeholder="リリースのキャッチコピーを35文字以内で入力してください。"
                @change="validateSubmitForm('catchCopyJapanese')" />
              <div class="form--error">
                <p
                  v-if="submitError.catchCopyJapanese"
                  class="error-text">
                  {{ submitError.catchCopyJapanese }}
                </p>
              </div>
              <div class="form-label">
                <label
                  class="control-label">英語 :</label>
              </div>
              <textarea
                id="catchCopyEnglish"
                v-model="submitData.catchCopyEnglish"
                maxlength="80"
                class="form-control"
                type="text"
                placeholder="リリースのキャッチコピーを英語で80文字以内で入力してください。"
                @change="validateSubmitForm('catchCopyEnglish')" />
              <div class="form--error">
                <p
                  v-if="submitError.catchCopyEnglish"
                  class="error-text">
                  {{ submitError.catchCopyEnglish }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-group">
            <div class="form-label">
              <span class="control-label control-required">*</span>
              <label
                class="control-label">リリース概要 :</label>
            </div>
            <div class="form-item">
              <div class="form-label">
                <label
                  class="control-label">日本語 :</label>
              </div>
              <textarea
                id="releaseOverviewJapanese"
                v-model="submitData.releaseOverviewJapanese"
                maxlength="35"
                class="form-control"
                type="text"
                placeholder="リリースの概要を35文字以内で入力してください。"
                @change="validateSubmitForm('releaseOverviewJapanese')" />
              <div class="form--error">
                <p
                  v-if="submitError.releaseOverviewJapanese"
                  class="error-text">
                  {{ submitError.releaseOverviewJapanese }}
                </p>
              </div>
              <div class="form-label">
                <label
                  class="control-label">英語 :</label>
              </div>
              <textarea
                id="releaseOverviewEnglish"
                v-model="submitData.releaseOverviewEnglish"
                maxlength="80"
                class="form-control"
                type="text"
                placeholder="リリースの概要を英語で80文字以内で入力してください。"
                @change="validateSubmitForm('releaseOverviewEnglish')" />
              <div class="form--error">
                <p
                  v-if="submitError.releaseOverviewEnglish"
                  class="error-text">
                  {{ submitError.releaseOverviewEnglish }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-pad">
            <div class="control-label">
              ＊SNS情報 :
            </div>
            <div class="profile-info">
              <div class="form-wrap form-wrap--profile u-no-margin-top">
                <accordion
                  :is-open="isOpen"
                  @toggle="accordionToggle">
                  <div
                    slot="title"
                    class="accordion-title__text">
                    詳細情報入力エリアを{{ isOpen?'閉じる':'開く' }}
                  </div>
                  <div
                    slot="content"
                    class="content_block">
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">Official Site :
                        </label>
                      </div>
                      <div class="form-item">
                        <input
                          v-model="submitData.officialSite"
                          type="text"
                          placeholder="https://narasu.jp/"
                          class="form-text-site">
                      </div>
                    </div>
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">Other :
                        </label>
                      </div>
                      <div class="form-item">
                        <input
                          v-model="submitData.otherSite"
                          type="text"
                          placeholder="https://narasu.jp/"
                          class="form-text-site">
                      </div>
                    </div>
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">X</label>
                      </div>
                      <div class="form-item d-flex">
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">アカウント名 :</label>
                          <input
                            v-model="snsInformation.twitter.accountId"
                            type="text"
                            placeholder="@narasu_jp"
                            class="form-text">
                        </div>
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">フォロワー数 :</label>
                          <input
                            v-model="snsInformation.twitter.follower"
                            type="text"
                            placeholder="フォロワー数"
                            class="form-text">
                        </div>
                      </div>
                    </div>
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">Youtube</label>
                      </div>
                      <div class="form-item d-flex">
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">アカウント名 :</label>
                          <input
                            v-model="snsInformation.youtube.accountId"
                            type="text"
                            placeholder="https://youtube.com/@narasu"
                            class="form-text">
                        </div>
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">チャンネル登録者数 :</label>
                          <input
                            v-model="snsInformation.youtube.follower"
                            type="text"
                            placeholder="チャンネル登録者数"
                            class="form-text">
                        </div>
                      </div>
                    </div>
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">Instagram</label>
                      </div>
                      <div class="form-item d-flex">
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">アカウント名 :</label>
                          <input
                            v-model="snsInformation.instagram.accountId"
                            type="text"
                            placeholder="narasu_jp"
                            class="form-text">
                        </div>
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">フォロワー数 :</label>
                          <input
                            v-model="snsInformation.instagram.follower"
                            type="text"
                            placeholder="フォロワー数"
                            class="form-text">
                        </div>
                      </div>
                    </div>
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">Soundcloud</label>
                      </div>
                      <div class="form-item d-flex">
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">アカウント名 :</label>
                          <input
                            v-model="snsInformation.soundcloud.accountId"
                            type="text"
                            placeholder="narasu_jp"
                            class="form-text">
                        </div>
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">フォロワー数 :</label>
                          <input
                            v-model="snsInformation.soundcloud.follower"
                            type="text"
                            placeholder="フォロワー数"
                            class="form-text">
                        </div>
                      </div>
                    </div>
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">TikTok</label>
                      </div>
                      <div class="form-item d-flex">
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">アカウント名 :</label>
                          <input
                            v-model="snsInformation.tiktok.accountId"
                            type="text"
                            placeholder="@narasu_jp"
                            class="form-text">
                        </div>
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">フォロワー数 :</label>
                          <input
                            v-model="snsInformation.tiktok.follower"
                            type="text"
                            placeholder="フォロワー数"
                            class="form-text">
                        </div>
                      </div>
                    </div>
                    <div class="form-group js-tooltip">
                      <div class="form-label">
                        <label class="control-label">Facebook</label>
                      </div>
                      <div class="form-item d-flex">
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">アカウント名 :</label>
                          <input
                            v-model="snsInformation.facebook.accountId"
                            type="text"
                            placeholder="https://www.facebook.com/narasu.jp"
                            class="form-text">
                        </div>
                        <div class="form-label d-flex flex-column align-baseline">
                          <label
                            class="control-label">フォロワー数 :</label>
                          <input
                            v-model="snsInformation.facebook.follower"
                            type="text"
                            placeholder="フォロワー数"
                            class="form-text">
                        </div>
                      </div>
                    </div>
                  </div>
                </accordion>
              </div>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label">MV先行公開楽曲 :</label>
            </div>
            <div
              class="form-item-inline">
              <div class="checkbox">
                <label
                  v-for="(title, index) in productTrackTitles"
                  :key="index">
                  <input
                    v-model="mvPrereleaseSong"
                    :value="title"
                    type="checkbox">
                  <div class="option-input"></div> {{ title }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-pad ">
            <ul class="check-list">
              <li class="check-list__node check-list__node-img">
                <span class="control-label control-required">*</span>
                <label class="control-label">アーティスト写真（正方形）</label>
                <div class="release-jacket-area">
                  <div
                    class="release-jacket-area__pic">
                    <img
                      class="preview-image"
                      :src="previewImageSquare" />
                  </div>
                  <div
                    v-if="previewImageSquare"
                    class="release-jacket-area__upload-box release-jacket-area__upload-box--on">
                    <div class="release-jacket-area__upload-text">
                    </div>
                    <a
                      class="c-btn c-btn--release"
                      href="#"
                      @click.prevent="onUploadClicked(true)">
                      画像ファイルを選択
                      <span class="c-btn__icon-arrow"></span>
                    </a>
                  </div>
                  <div
                    v-if="!previewImageSquare"
                    class="release-jacket-area__upload-box">
                    <a
                      class="c-btn c-btn--release"
                      href="#"
                      @click.prevent="onUploadClicked(true)">
                      画像ファイルを選択
                      <span class="c-btn__icon-arrow"></span>
                    </a>
                  </div>
                  <input
                    ref="fileSquare"
                    type="file"
                    style="display:none"
                    accept="image/png,image/jpeg"
                    @change="onFileChanged($event, true)" />
                </div>
                <div class="form--error">
                  <div
                    v-if="submitError.artistImageSquare"
                    class="error-text">
                    <div
                      v-for="(trackError, index) in submitError.artistImageSquare"
                      :key="index">
                      {{ trackError }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-pad ">
            <ul class="check-list">
              <li class="check-list__node check-list__node-img">
                <span class="control-label control-required">*</span>
                <label class="control-label">アーティスト写真（長方形）</label>
                <div class="release-jacket-area">
                  <div class="release-jacket-area__pic release-jacket-area__pic-rect ">
                    <img
                      class="preview-image"
                      :src="previewImageRectangle" />
                  </div>
                  <div
                    v-if="previewImageRectangle"
                    class="release-jacket-area__upload-box release-jacket-area__upload-box--on">
                    <div class="release-jacket-area__upload-text">
                    </div>
                    <a
                      class="c-btn c-btn--release"
                      href="#"
                      @click.prevent="onUploadClicked(false)">
                      画像ファイルを選択
                      <span class="c-btn__icon-arrow"></span>
                    </a>
                  </div>
                  <div
                    v-if="!previewImageRectangle"
                    class="release-jacket-area__upload-box">
                    <a
                      class="c-btn c-btn--release"
                      href="#"
                      @click.prevent="onUploadClicked(false)">
                      画像ファイルを選択
                      <span class="c-btn__icon-arrow"></span>
                    </a>
                  </div>
                  <input
                    ref="fileRectangle"
                    type="file"
                    style="display:none"
                    accept="image/png,image/jpeg"
                    @change="onFileChanged($event, false)" />
                </div>
                <div class="form--error">
                  <div
                    v-if="submitError.artistImageRectangle"
                    class="error-text">
                    <div
                      v-for="(trackError, index) in submitError.artistImageRectangle"
                      :key="index">
                      {{ trackError }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-pad ">
            <label>宣伝用の資料等 </label>
            <div
              class="release-jacket-area__upload-box">
              <a
                class="c-btn c-btn--release"
                href="#"
                @click.prevent="onUploadMultipleClicked()">
                ファイルを選択
                <span class="c-btn__icon-arrow"></span>
              </a>
            </div>
            <div class="release-jacket-area">
              <div
                v-for="(file, index) in submitData.promotionalMaterials"
                :key="index"
                class="uploaded-items">
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 48 48"
                  xmlns="http://www.w3.org/2000/svg"
                  @click="cancelImage(index)">
                  <title>close-circle</title>
                  <g
                    id="Layer_2"
                    data-name="Layer 2">
                    <g
                      id="invisible_box"
                      data-name="invisible box">
                      <rect
                        width="48"
                        height="48"
                        fill="none" />
                    </g>
                    <g
                      id="icons_Q2"
                      data-name="icons Q2">
                      <path
                        d="M24,6A18,18,0,1,1,6,24,18.1,18.1,0,0,1,24,6m0-4A22,
                    22,0,1,0,46,24,21.9,21.9,0,0,0,24,2Z" />
                      <path
                        d="M26.8,24l5.6-5.5a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,
                    0,0,0-3-.2L24,21.2l-5.6-5.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,
                    0,0,0,.2,2.7L21.2,24l-5.6,5.5a2.1,2.1,0,0,0-.2,2.7,1.9,
                    1.9,0,0,0,3,.2L24,26.8l5.6,5.6a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7Z" />
                    </g>
                  </g>
                </svg>
                <p>
                  {{ file.name }}
                </p>
              </div>
              <input
                ref="multipleFile"
                type="file"
                multiple="multiple"
                max="3"
                accept="image/png,image/jpeg,application/pdf,application/msword,
              application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                style="display:none"
                @change="onMultipleFileChange($event)" />
            </div>
            <div class="form--error">
              <p
                v-if="submitError.promotionalMaterials"
                class="error-text">
                {{ submitError.promotionalMaterials }}
              </p>
            </div>
          </div>
        </div>

        <div class="form-wrap">
          <div class="form-pad ">
            ※注意事項 <br />
            私は、利用規約に同意のうえ配信を依頼します。<br>
            私は、本リリースに関し、選択した全ての地域において配信する正当な権利を保持しています。<br />
            私は、本リリースが原則として自動更新となることを確認しました。<br />
            私は、未成年ではありません。または保護者の同意を得ました。<br />
            配信審査依頼後はリリース情報及び決済方法の変更はできません。<br />
            注意事項を確認しました<br />
          </div>
        </div>

        <div class="confirm-checkbox-area">
          <div
            class="checkbox"
            @click="showErrors">
            <label>
              <input
                v-model="submitData.consent"
                value="true"
                :disabled="submitErrorKeys.length>0"
                type="checkbox">
              <div class="option-input"></div> 注意事項を確認しました
            </label>
          </div>
        </div>

        <div class="c-btn-wrap">
          <a
            href="#"
            class="c-btn c-btn--back c-btn--back-left"
            @click.prevent="onBackClicked">
            サブミットをキャンセル
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </a>
          <a
            class="c-btn"
            :class="{ 'c-btn--off': !submitData.consent }"
            @click="goToSubmitConfirm">
            確認へ
          </a>
        </div>
      </form>
      <confirm-dialog
        name="backFromRelease"
        :is-shown="confirmDialogSubmit"
        title="本当にサブミットをキャンセルしますか？"
        @closed="onBackCanceled"
        @default-clicked="onBackConfirmed"
        @cancel-clicked="onBackCanceled">
        <template #body>
          サブミットをキャンセルしても、設定した配信日は変 <br />
          更できません。よろしいですか？
        </template>
      </confirm-dialog>
    </div>
    <submit-confirm
      v-else
      :submit-data="submitData"
      :sns-information="snsInformation"
      :mv-prerelease-song="mvPrereleaseSong"
      @onSubmit="submitForm"
      @onReturn="returnToSubmit" />
  </div>
</template>

<script>
import moment from 'moment-timezone'
import Accordion from '../../Accordion'
import AlertView from '../../AlertView'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import SubmitConfirm from './SubmitConfirm'
import ReleaseTypeLabel from '../ReleaseTypeLabel'

export default {
  name: 'Submit',
  components: {
    AlertView,
    Accordion,
    ConfirmDialog,
    ReleaseTypeLabel,
    SubmitConfirm,
  },
  data() {
    return {
      productId: '',
      productTrackTitles: [],
      isDisabled: false,
      enableCheckBox: false,
      isOpen: false,
      janCode: '',
      artists: [],
      songName: '',
      submitData: {
        artistActivityHistory: '2年以内',
        isDebut: 'いいえ',
        cdReleaseSchedule: 'あり',
        catchCopyJapanese: '',
        catchCopyEnglish: '',
        releaseOverviewJapanese: '',
        releaseOverviewEnglish: '',
        officialSite: '',
        otherSite: '',
        consent: false,
        squareFile: null,
        rectangleFile: null,
        promotionalMaterials: [],
      },
      submitErrorKeys: [
        'catchCopyJapanese',
        'catchCopyEnglish',
        'releaseOverviewJapanese',
        'releaseOverviewEnglish',
        'squareFile',
        'rectangleFile',
      ],
      submitError: {
        catchCopyJapanese: '',
        catchCopyEnglish: '',
        releaseOverviewJapanese: '',
        releaseOverviewEnglish: '',
        artistImageSquare: [],
        artistImageRectangle: [],
        promotionalMaterials: '',
      },
      mvPrereleaseSong: [],
      previewImageSquare: null,
      previewImageRectangle: null,
      snsInformation: {
        twitter: {
          accountId: '',
          follower: '',
        },
        youtube: {
          accountId: '',
          follower: '',
        },
        instagram: {
          accountId: '',
          follower: '',
        },

        soundcloud: {
          accountId: '',
          follower: '',
        },

        tiktok: {
          accountId: '',
          follower: '',
        },

        facebook: {
          accountId: '',
          follower: '',
        },
      },
      discs: [{ tracks: [] }],
      squareFile: null,
      rectangleFile: null,
      submitDay: 28,
      confirmProductErrors: {},
      confirmDialogSubmit: false,
      isSubmitConfirmed: false,
      type: '',
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    // セッションから値を復元
    if (!window.sessionStorage.getItem('album')) {
      this.$router.push({ name: 'index' })
      return
    }
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    this.productId = release.product.id
    this.discs = release.discs
    this.type = release.type
    this.getSubmitDays()
    this.artists = release.artists
    this.janCode = release.product.jan
    this.songName = release.product.title_ja
    this.discs.forEach(disc => {
      disc.tracks.forEach(track => {
        this.productTrackTitles.push(track.title_ja)
      })
    })
  },
  methods: {
    accordionToggle() {
      this.isOpen = !this.isOpen
    },
    handleValidation(event) {
      this.isDisabled = event.target.id === 'moreThan2years'
      if (this.isDisabled === true) {
        this.submitData.isDebut = 'いいえ'
      }
    },
    onUploadClicked(isSquare) {
      if (isSquare === true) {
        this.$refs.fileSquare.value = ''
        this.$refs.fileSquare.click()
      } else {
        this.$refs.fileRectangle.value = ''
        this.$refs.fileRectangle.click()
      }
    },
    onUploadMultipleClicked() {
      this.$refs.multipleFile.click()
    },
    onFileChanged(e, isSquare) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.onload = event => {
        this.checkImage(files[0], event, isSquare)
      }
      reader.readAsDataURL(files[0])
    },
    onMultipleFileChange(e) {
      const currentSelected = Array.from(e.target.files)
      const imageCount = currentSelected.length + this.submitData.promotionalMaterials.length
      if (imageCount > 3) {
        this.submitError.promotionalMaterials = '複数ファイルアップロード可能（3つまで）'
      } else {
        currentSelected.forEach(selected => this.submitData.promotionalMaterials.push(selected))
        this.submitError.promotionalMaterials = ''
        this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== 'promotionalMaterials')
      }
    },
    cancelImage(index) {
      this.submitData.promotionalMaterials.splice(index, 1)
      this.submitError.promotionalMaterials = ''
      this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== 'promotionalMaterials')
    },
    async getSubmitDays() {
      const currentDate = new Date().toISOString().substr(0, 10)
      const { data } = await window.axios.get('/api/client/submitDate/getDay', {
        params: {
          currentDate,
        },
      })
      this.submitDay = data
    },
    fetchError(errorList) {
      const errors = {}
      const uniqueArray = errorList.filter(entry => {
        if (!errors[entry]) {
          errors[entry] = true
          return true
        }
        return false
      })
      this.confirmProductErrors = uniqueArray
    },
    async checkImage(file, event, isSquare) {
      this.$store.dispatch('progress/updateName', file.name)
      const base64image = event.target.result
      const formData = new FormData()
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent
          const progressValue = Math.round((loaded / total) * 100)
          this.$store.dispatch('progress/updateLoaded', progressValue)
          this.$store.dispatch(
            'progress/updateText',
            `1個中の1個のファイルをアップロード中 (${progressValue}%)`,
          )
        },
      }
      if (isSquare === true) {
        formData.append('artistSquare', file)
        const { data } = await window.axios.post('/api/client/image/validate/submit/square', formData, config)
        this.$store.dispatch('progress/reset')
        this.submitError.artistImageSquare = []
        if (data.result === true) {
          this.previewImageSquare = base64image
          this.submitData.squareFile = new File([file], `artist_image_square.${file.name.split('.')[1]}`)
          this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== 'squareFile')
        } else {
          this.submitError.artistImageSquare.push('・2400 × 2400ピクセル以上の正方形の画像をアップロードしてください。')
          this.submitError.artistImageSquare.push('・RGBカラーモードの画像をアップロードしてください。')
          this.submitErrorKeys.push('squareFile')
          this.submitData.squareFile = null
        }
      } else {
        formData.append('artistRectangle', file)
        const { data } = await window.axios.post('/api/client/image/validate/submit/rectangle', formData, config)
        this.$store.dispatch('progress/reset')
        this.submitError.artistImageRectangle = []
        if (data.result === true) {
          this.previewImageRectangle = base64image
          this.submitData.rectangleFile = new File([file], `artist_image_rectangle.${file.name.split('.')[1]}`)
          this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== 'rectangleFile')
        } else {
          this.submitError.artistImageRectangle.push('・4000 × 2000ピクセル以上の長方形の画像をアップロードしてください。')
          this.submitError.artistImageRectangle.push('・RGBカラーモードの画像をアップロードしてください。')
          this.submitErrorKeys.push('rectangleFile')
          this.submitData.rectangleFile = null
        }
      }
    },

    validateSubmitForm(key) {
      switch (key) {
        case 'catchCopyJapanese':
          if (this.submitData.catchCopyJapanese === '') {
            this.submitError.catchCopyJapanese = 'リリースのキャッチコピーを35文字以内で入力してください。'
            this.submitErrorKeys.push(key)
          } else {
            this.submitError.catchCopyJapanese = ''
            this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== key)
          }
          break
        case 'catchCopyEnglish':
          if (this.submitData.catchCopyEnglish === '') {
            this.submitError.catchCopyEnglish = 'リリースのキャッチコピーを英語で80文字以内で入力してください。'
            this.submitErrorKeys.push(key)
          } else {
            this.submitError.catchCopyEnglish = ''
            this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== key)
          }
          break
        case 'releaseOverviewJapanese':
          if (this.submitData.releaseOverviewJapanese === '') {
            this.submitError.releaseOverviewJapanese = 'リリースの概要を35文字以内で入力してください。'
            this.submitErrorKeys.push(key)
          } else {
            this.submitError.releaseOverviewJapanese = ''
            this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== key)
          }
          break
        case 'releaseOverviewEnglish':
          if (this.submitData.releaseOverviewEnglish === '') {
            this.submitError.releaseOverviewEnglish = 'リリースの概要を英語で80文字以内で入力してください。'
            this.submitErrorKeys.push(key)
          } else {
            this.submitError.releaseOverviewEnglish = ''
            this.submitErrorKeys = this.submitErrorKeys.filter(value => value !== key)
          }
          break
        default:
          break
      }
    },
    showErrors() {
      if (this.submitErrorKeys.length > 0) {
        for (let i = 0; i < this.submitErrorKeys.length; i += 1) {
          switch (this.submitErrorKeys[i]) {
            case 'catchCopyJapanese':
              this.submitError.catchCopyJapanese = 'リリースのキャッチコピーを35文字以内で入力してください。'
              break
            case 'catchCopyEnglish':
              this.submitError.catchCopyEnglish = 'リリースのキャッチコピーを英語で80文字以内で入力してください。'
              break
            case 'releaseOverviewJapanese':
              this.submitError.releaseOverviewJapanese = 'リリースの概要を35文字以内で入力してください。'
              break
            case 'releaseOverviewEnglish':
              this.submitError.releaseOverviewEnglish = 'リリースの概要を英語で80文字以内で入力してください。'
              break
            case 'squareFile':
              this.submitError.artistImageSquare = []
              this.submitError.artistImageSquare.push('・2400 × 2400ピクセル以上の正方形の画像をアップロードしてください。')
              this.submitError.artistImageSquare.push('・RGBカラーモードの画像をアップロードしてください。')
              break
            case 'rectangleFile':
              this.submitError.artistImageRectangle = []
              this.submitError.artistImageRectangle.push('・4000 × 2000ピクセル以上の長方形の画像をアップロードしてください。')
              this.submitError.artistImageRectangle.push('・RGBカラーモードの画像をアップロードしてください。')
              break
            case 'promotionalMaterials':
              this.submitError.promotionalMaterials = '複数ファイルアップロード可能（3つまで）'
              break
            default:
              break
          }
        }
      }
    },
    onBackClicked() {
      // window.location.href = '/client/release-single/step3'
      this.confirmDialogSubmit = true
      // show confirm dialog here
    },
    async submitFormConfirmed() {
      const form = new FormData()
      Object.keys(this.submitData)
        .forEach((key) => form.append(key, this.submitData[key]), this)
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent
          const progressValue = Math.round((loaded / total) * 100)
          this.$store.dispatch('progress/updateLoaded', progressValue)
          this.$store.dispatch(
            'progress/updateText',
            `1個中の1個のファイルをアップロード中 (${progressValue}%)`,
          )
        },
      }
      form.append('snsInformation', JSON.stringify(this.snsInformation))
      form.append('janCode', this.janCode)
      form.append('artists', JSON.stringify(this.artists))
      form.append('songName', this.songName)
      form.append('productId', this.productId)
      if (this.mvPrereleaseSong.length > 0) {
        this.mvPrereleaseSong.forEach((song) => {
          form.append('mvPrereleaseSong[]', song)
        })
      } else { form.append('mvPrereleaseSong', '') }
      form.append('artistSquare', this.submitData.squareFile)
      form.append('artistRectangle', this.submitData.rectangleFile)
      for (let i = 0; i < this.submitData.promotionalMaterials.length; i += 1) {
        const file = this.submitData.promotionalMaterials[i]
        form.append(`promotionalMaterials[${i}]`, file)
      }
      await window.axios.post('/api/client/submit', form, config)
    },
    goToSubmitConfirm() {
      this.isSubmitConfirmed = true
    },
    returnToSubmit() {
      this.isSubmitConfirmed = false
    },
    async submitForm() {
      await this.submitFormConfirmed()
      await this.$store.dispatch('progress/reset')
      await this.$router.push({ name: `${this.$route.meta.sideMenuId}-submit-completed` })
    },
    updateDate(event) {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      this.providers.forEach(provider => {
        if (this.initialSubmitReleaseValue) this.subtractDate(event.target.value === 'true', release, provider)
        else this.addDate(event.target.value === 'true', release, provider)
      })
    },
    addDate(isReleaseSubmit, release, provider) {
      if (isReleaseSubmit) {
        this.$set(
          this.providerSchedules,
          provider.key,
          release.providerSchedules && release.providerSchedules[provider.key]
            ? moment(new Date(release.providerSchedules[provider.key])).add(this.submitData, 'd')
            : moment(new Date(provider.min_release_date)).add(this.submitData, 'd'),
        )
        this.$set(this.providerMinSchedules,
          provider.key,
          release.providerSchedules && release.providerSchedules[provider.key]
            ? moment(new Date(release.providerSchedules[provider.key])).add(this.submitData, 'd')
            : moment(new Date(provider.min_release_date)).add(this.submitData, 'd'))
      } else {
        this.$set(
          this.providerSchedules,
          provider.key,
          release.providerSchedules && release.providerSchedules[provider.key]
            ? release.providerSchedules[provider.key]
            : provider.min_release_date,
        )
        this.$set(this.providerMinSchedules, provider.key, provider.min_release_date)
      }
    },
    subtractDate(isReleaseSubmit, release, provider) {
      if (!isReleaseSubmit) {
        this.$set(
          this.providerSchedules,
          provider.key,
          release.providerSchedules && release.providerSchedules[provider.key]
            ? moment(new Date(release.providerSchedules[provider.key])).subtract(this.submitData, 'd')
            : moment(new Date(provider.min_release_date)).subtract(this.submitData, 'd'),
        )
        this.$set(this.providerMinSchedules,
          provider.key,
          release.providerSchedules && release.providerSchedules[provider.key]
            ? moment(new Date(release.providerSchedules[provider.key])).subtract(this.submitData, 'd')
            : moment(new Date(provider.min_release_date)).subtract(this.submitData, 'd'))
      } else {
        this.$set(
          this.providerSchedules,
          provider.key,
          release.providerSchedules && release.providerSchedules[provider.key]
            ? release.providerSchedules[provider.key]
            : provider.min_release_date,
        )
        this.$set(this.providerMinSchedules,
          provider.key,
          release.providerSchedules && release.providerSchedules[provider.key]
            ? release.providerSchedules[provider.key]
            : provider.min_release_date)
      }
    },
    onBackCanceled() {
      this.confirmDialogSubmit = false
    },
    onBackConfirmed() {
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-submit-canceled` })
    },
  },
}
</script>

<style scoped>

.check-list {
  align-items: center;
}

.list-flex {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.check-list__node-img {
  margin: 10px 0;
  width: auto;
}

.check-list__node > label {
  font-weight: bold;
}

.list-flex div {
  display: flex;
  align-items: center;
}

.form-pad {
  padding: 24px 0;
}

.form-item textarea {
  margin: 4px 0;
}

.form-item .form-control {
  width: 100%;
  height: 100px;
}

.form-item .form-text {
  width: 90%;
  height: 45px;
  border: 1px solid #d4cdc8;
  background-color: #fff;
}

.form-item .form-text-site {
  width: 39%;
  height: 45px;
  border: 1px solid #d4cdc8;
  background-color: #fff;
}

.control-label {
  font-weight: bold;
}

.release-jacket-area {
  align-items: center;
}

.form-item input {
  margin: 4px 0;
}

.release-jacket-area__upload-box {
  padding: 30px 25px;
  width: auto;
  margin: auto;
  justify-content: center;
}

.release-jacket-area__pic {
  width: 240px;
  height: 240px;
  background: #d0d0d0 url("../../../../../../public/img/common/icon-image_white.png")
  no-repeat center center;
  background-size: 73px auto;
}

.release-jacket-area__pic img {
  top: 50%;
  left: 0;
  height: auto;
  transform: none;
  position: initial;
}

@media screen and (min-width: 896px) {
  .preview-image {
    width: 240px;
    height: 240px;
  }
}

@media screen and (max-width: 895px) {
  .preview-image {
    width: 50vw;
    height: 50vw;
  }
}

.release-jacket-area__pic-rect {
  height: 120px;
}

.control-required {
  color: red;
  font-size: large;
}

.uploaded-items {
  background: #e3e3e3;
  margin: 0 20px;
  padding: 4px 10px;
  border-radius: 6px;
  position: relative;
}

.uploaded-items svg {
  position: absolute;
  right: -10px;
  top: -8px;
}

.d-flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.align-baseline {
  align-items: baseline;
}

</style>
